const MS_THRESHOLD = 1e12;
const MIN_FIRESTORE_SECONDS = -62135596800; // Segundos negativos são válidos: o epoch Unix é 1970, então nascimento em 1968 fica abaixo de zero.
const MAX_FIRESTORE_SECONDS = 253402300799;
const MIN_REASONABLE_YEAR = 1900;
const MAX_REASONABLE_YEAR = 2100;

function toMillis(value) {
  if (value == null || value === "") return null;

  if (typeof value?.toDate === "function") {
    const d = value.toDate();
    return Number.isNaN(d.getTime()) ? null : d.getTime();
  }

  if (value instanceof Date) {
    return Number.isNaN(value.getTime()) ? null : value.getTime();
  }

  if (typeof value === "object") {
    const sec = value.seconds ?? value._seconds;
    if (typeof sec === "number") {
      return sec > MS_THRESHOLD ? sec : sec * 1000;
    }
  }

  if (typeof value === "number") {
    if (!Number.isFinite(value)) return null;
    return value < MS_THRESHOLD ? value * 1000 : value;
  }

  if (typeof value === "string") {
    const trimmed = value.trim();
    if (!trimmed) return null;

    // yyyy-MM-dd do <input type="date">
    if (/^\d{4}-\d{2}-\d{2}$/.test(trimmed)) {
      const [y, m, d] = trimmed.split("-").map(Number);
      const local = new Date(y, m - 1, d);
      return Number.isNaN(local.getTime()) ? null : local.getTime();
    }

    const parsed = Date.parse(trimmed);
    return Number.isNaN(parsed) ? null : parsed;
  }

  return null;
}

function isReasonableYear(ms) {
  const year = new Date(ms).getFullYear();
  return year >= MIN_REASONABLE_YEAR && year <= MAX_REASONABLE_YEAR;
}

export function toDateInputValue(value) {
  const ms = toMillis(value);
  if (ms == null || !isReasonableYear(ms)) return "";

  const d = new Date(ms);
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
}

export function toFirestoreDate(value) {
  const ms = toMillis(value);
  if (ms == null || !isReasonableYear(ms)) return null;

  const seconds = Math.floor(ms / 1000);
  if (seconds < MIN_FIRESTORE_SECONDS || seconds > MAX_FIRESTORE_SECONDS) {
    return null;
  }

  return new Date(ms);
}

export function omitNullish(obj) {
  if (!obj || typeof obj !== "object") return obj;
  return Object.fromEntries(
    Object.entries(obj).filter(([, v]) => v !== null && v !== undefined),
  );
}
